import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Typography from "@mui/material/Typography";
import ActivityBar from "../../components/Reusable/ActivityBar/ActivityBar";
import Styles from "./Operations.module.css";
import { apiService } from "../../api/apiService";
import { Box } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";


interface Location {
  name: string;
  description: string;
  type: string;
  id: number;
  url: string;
}

interface OperationsProps {
  // manager?: boolean;
  // user?: boolean;
  // admin?: boolean;
  // processmapManager?: boolean;
  // processmapAdmin?: boolean;
  // processmapUser?: boolean;
  // routinePerformanceManager?: boolean;
  // globalManager?: boolean;
  // frontlineManager?: boolean;
  // projectManager?: boolean;
  strategyTab?: boolean;
}

const breadcrumbs = [
  <Link key="1" color="#000" to="/">
    Home
  </Link>,
  <Typography key="2">Evidence Upload</Typography>,
];

const Operations: React.FC<OperationsProps> = ({ strategyTab }) => {
  const { instance } = useMsal();
  const [error, setError] = useState<string | null>(null);

  const location = useLocation();
  const [locations, setLocations] = useState<Location[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState<"management" | "people">("management");
  const [strategyActiveTab, setstrategyActiveTab] = useState<"Vision & Strategy planning" | "Value Creation through resources allocation">("Vision & Strategy planning");
  const role = localStorage.getItem("role");

  useEffect(() => {

    const fetchLocations = async () => {
      setIsLoading(true);
      setError(null); // Reset error state on new request

      try {
        const jsonResponse = await apiService(
          "/static_management",
          "GET",
          undefined,
          undefined,
          instance as PublicClientApplication
        );

        if (jsonResponse?.status === "success" && Array.isArray(jsonResponse.data)) {
          const formattedData = jsonResponse.data.map((item: any) => ({
            name: item.name,
            description: item.description,
            type: item.type,
            id: item.id || Math.random(),
          }));
          setLocations(formattedData);
        } else {
          const errorMsg = jsonResponse?.message || "Unexpected API response format";
          setError(errorMsg);
          console.error("API Error:", errorMsg, jsonResponse);
        }
      } catch (error) {
        let errorMessage = "Failed to fetch locations";

        if (error instanceof Error) {
          // Handle API error responses (4xx/5xx)
          if (error.message.includes("401")) {
            errorMessage = "Session expired - please try again";
          } else if (error.message.includes("Network Error")) {
            errorMessage = "Network connection failed";
          } else {
            // Try to extract server error message
            try {
              const errorData = JSON.parse(error.message.replace("HTTP error! ", ""));
              errorMessage = errorData.message || error.message;
            } catch {
              errorMessage = error.message;
            }
          }
        }

        setError(errorMessage);
        console.error("API Error:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchLocations();
  }, []);

  const handleTabChange = (tab: "management" | "people") => {
    setActiveTab(tab);
  };

  const handleTabChange2 = (tab2: "Vision & Strategy planning" | "Value Creation through resources allocation") => {
    setstrategyActiveTab(tab2);
  };

  return (
    <>
      <ActivityBar breadcrumbs={breadcrumbs} />
      <div className={Styles.container}>
        <div className={Styles.operationBannerImg}>
          <div className={Styles.operationBanner}>
            <h1>Operations</h1>
            <p>Upload your documents here</p>
          </div>
        </div>
        <div className={Styles.operationBtns}>
          {strategyTab ? (
            <>
              <button
                className={
                  strategyActiveTab === "Vision & Strategy planning" ? Styles.activeBtn : Styles.inactiveBtn
                }
                onClick={() => handleTabChange2("Vision & Strategy planning")}
              >
                Vision & Strategy planning
              </button>

              {role === "user" || role === "manager" ? null : (
                <button
                  className={
                    strategyActiveTab === "Value Creation through resources allocation" ? Styles.activeBtn : Styles.inactiveBtn
                  }
                  onClick={() => handleTabChange2("Value Creation through resources allocation")}
                >
                  Value Creation through resources allocation
                </button>
              )}

             
            </>
          ) : (
            <>
              <button
                className={
                  activeTab === "management" ? Styles.activeBtn : Styles.inactiveBtn
                }
                onClick={() => handleTabChange("management")}
              >
                Management
              </button>

              <button
                className={
                  activeTab === "people" ? Styles.activeBtn : Styles.inactiveBtn
                }
                onClick={() => handleTabChange("people")}
              >
                People
              </button>
            </>
          )}

          {/* <button
            className={
              activeTab === "people" ? Styles.activeBtn : Styles.inactiveBtn
            }
            onClick={() => handleTabChange("people")}
          >
            People
          </button> */}
        </div>

        {/* Card Section */}
        <div className={Styles.operationCards}>
          {isLoading ? (
            <Typography>Fetching data...</Typography>
          ) : (
            <>
              {locations.map((loc) => (
                <Link
                  to={
                    strategyTab ? strategyActiveTab === "Vision & Strategy planning"
                      ? "/operations/strategy-value-creation/vsp"
                      : "/operations/strategy-value-creation/vctra/capex-opex" : activeTab === "management"
                      ? "/operations/management/global-policies"
                      : "/operations/people/culture"

                  }
                  state={{ management: loc.name }}
                  key={loc.id}
                  className={Styles.locationCard}
                  onClick={() => localStorage.setItem("management", loc.name)}
                >
                  <div className={Styles.cardArrow}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M7 17L17 7"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7 7H17V17"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className={Styles.cardContent}>
                    <h2 className={Styles.cardName}>{loc.name}</h2>
                  </div>
                </Link>

              ))}
            </>


          )}
        </div>
      </div>
    </>
  );
}
export default Operations;